export enum SearchFilterProfessionalGenderType {
  ALL = 'all',
  MALE = 'male',
  FEMALE = 'female',
}

export const SearchFilterProfessionalGenderMap: Record<SearchFilterProfessionalGenderType, string> = {
  [SearchFilterProfessionalGenderType.ALL]: 'Todos',
  [SearchFilterProfessionalGenderType.MALE]: 'Homens',
  [SearchFilterProfessionalGenderType.FEMALE]: 'Mulheres',
};

export const searchFilterProfessionalGenderOptions: SearchFilterProfessionalGenderType[] = [
  SearchFilterProfessionalGenderType.ALL,
  SearchFilterProfessionalGenderType.MALE,
  SearchFilterProfessionalGenderType.FEMALE,
];

export const PROFESSIONAL_GENDER_ANALYTICS_KEY = 'genero_profissional';

export const SearchFilterProfessionalGenderAnalyticsMap: Record<SearchFilterProfessionalGenderType, string> = {
  [SearchFilterProfessionalGenderType.ALL]: 'todos',
  [SearchFilterProfessionalGenderType.MALE]: 'homens',
  [SearchFilterProfessionalGenderType.FEMALE]: 'mulheres',
};
